import { Box, Button, Dialog, DialogContent, DialogTitle, Stack, TextField } from "@mui/material";
import { Snapshot } from "@shared/domain/snapshot/snapshot.aggregate";
import { snapshotRepository } from "@shared/domain/snapshot/snapshot.repository";
import { Toast } from "@shared/infrastructure/ui/components/toast/toast";
import { Dispatch, FormEvent, SetStateAction, useState } from "react";

export type SnapshotCreateProps = {
    countryCode: string;
    onCancel: () => void;
    onSubmit: (snapshot: Snapshot) => void;
};

const validateField = (
    value: string,
    validStateSetter: Dispatch<SetStateAction<boolean>>
) => {
    let isValid = true;
    if (!value.trim()) {
        isValid = false;
    }

    validStateSetter(!isValid);
    return isValid;
};

export const SnapshotCreate = (props: SnapshotCreateProps) => {
    const [name, setName] = useState("");
    const [nameError, setNameError] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const HandleCreate = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const isValidName = validateField(name, setNameError);

        if (!isValidName) {
            return;
        }

        setIsBusy(true);
        snapshotRepository
            .createSnapshot(props.countryCode, name)
            .then((snapshot) => {
                props.onSubmit(snapshot)
            })
            .catch(() => {
                setErrorMessage(
                    "An error occurred while creating the snapshot. Please try again."
                );
            })
            .finally(() => {
                setIsBusy(false);
            });
    };

    return (
        <>
            <Dialog
                open={true}
                onClose={(_event, reason) => {
                    if (reason === "backdropClick") {
                        return;
                    }
                    props.onCancel();
                }}
                disableRestoreFocus>
                <DialogTitle>Create snapshot</DialogTitle>
                <DialogContent>
                    <Box
                        sx={{ minWidth: 500 }}
                        id="snapshot-create-form"
                        component="form"
                        onSubmit={HandleCreate}
                        noValidate
                    >
                        <Stack spacing={2} padding={2}>
                            <TextField
                                id="name-input"
                                label="Name"
                                required
                                fullWidth
                                autoComplete="off"
                                autoFocus
                                value={name}
                                error={nameError}
                                onChange={(e) => setName(e.target.value)}
                            ></TextField>
                        </Stack>
                        <Stack
                            direction="row-reverse"
                            spacing={2}
                            padding={2}
                        >
                            <Button
                                variant="contained"
                                type="submit"
                                disabled={isBusy}
                            >
                                Create
                            </Button>
                            <Button
                                variant="outlined"
                                disabled={isBusy}
                                onClick={props.onCancel}
                                autoFocus>
                                Cancel
                            </Button>
                        </Stack>
                    </Box>
                </DialogContent>
            </Dialog>

            {errorMessage && (
                <Toast
                    isError={true}
                    message={errorMessage}
                    onClose={() => setErrorMessage("")}
                ></Toast>
            )}
        </>
    )
}